import formatUTCDate from '@/shared/tools/formatUTCDate'

// || '' is used to prevent sending 'null' as a string value

export const contactSaveParametersGeneration = ({ customerData, id, country, action }) => {
  const options = new URLSearchParams()

  if (action !== '') {
    options.append('action_requested', action)
  }

  const {
    personal: {
      zohoId,
      civility = '-1',
      lastName = '',
      firstName = '',
      email = '',
      phone1 = '',
      phone2 = '',
      birthdate = '',
      bornCity = '',
    },
    preferences: { dataCollectionAuth, neverBounceResult, callbackTime, callbackDate, clientType },
    professional: { socialReason, siret, apeCode },
    additional: { comments = '' } = {},
    identity: {
      documentType = '',
      documentNumber = '',
      expirationDate = '',
      createdDate = '',
      issuingEntity = '',
      issuingCity = '',
      taxIdCode = '',
    } = {},
  } = customerData

  options.append('id', id)
  options.append('zoho_id', zohoId)
  options.append('lang', country)

  // Preferences
  options.append('disclaimer', dataCollectionAuth ? '1' : '0')
  options.append('neverbounce_result', neverBounceResult)

  if (callbackTime !== '' && callbackDate !== '') {
    const date = new Date(`${callbackDate} ${callbackTime}`).toISOString().slice(0, 19)
    options.append('web_callback', formatUTCDate(date) || '')
  }

  // Professional
  options.append('pro_social_reason', socialReason || '')
  options.append('pro_siret', siret || '')
  options.append('pro_ape_code', apeCode || '')
  options.append('is_professional', clientType === 'pro' ? '1' : '0')

  // Personal data
  options.append('civility', civility || '')
  options.append('lastname', lastName || '')
  options.append('firstname', firstName || '')
  options.append('email', email || '')
  if (birthdate) options.append('birthday', birthdate)
  if (bornCity) options.append('born_city', bornCity)
  options.append('phone1', phone1 || '')
  options.append('phone2', phone2 || '')

  // Identity document
  if (documentType) options.append('identity_document_type', documentType)
  if (documentNumber) options.append('identity_document_number', documentNumber)
  if (expirationDate) options.append('identity_expiration_date', expirationDate)
  if (createdDate) options.append('identity_created_date', createdDate)
  if (issuingEntity) options.append('identity_issuing_entity', issuingEntity)
  if (issuingCity) options.append('identity_issuing_city', issuingCity)
  options.append('identity_tax_id_code', taxIdCode || '')

  // Additional data
  if (comments !== '') {
    options.append('subscription_comments', comments)
  }

  return options
}
